"use strict";

var _toConsumableArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/toConsumableArray.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateTimeType = void 0;
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _primitivePreview = _interopRequireDefault(require("../preview/primitivePreview"));
var _constants = require("./constants");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var OVERRIDABLE_FIELDS = _toConsumableArray(_constants.DEFAULT_OVERRIDEABLE_FIELDS);
var DATETIME_CORE = {
  name: 'datetime',
  title: 'Datetime',
  type: null,
  jsonType: 'string'
};
var DateTimeType = {
  get: function get() {
    return DATETIME_CORE;
  },
  extend: function extend(subTypeDef) {
    var parsed = Object.assign((0, _pick2.default)(DATETIME_CORE, OVERRIDABLE_FIELDS), subTypeDef, {
      type: DATETIME_CORE,
      preview: _primitivePreview.default
    });
    return subtype(parsed);
    function subtype(parent) {
      return {
        get: function get() {
          return parent;
        },
        extend: function extend(extensionDef) {
          var current = Object.assign({}, parent, (0, _pick2.default)(extensionDef, OVERRIDABLE_FIELDS), {
            type: parent
          });
          return subtype(current);
        }
      };
    }
  }
};
exports.DateTimeType = DateTimeType;